export const PAGE_SIZES = [50, 100, 250, 500];

export const DEFAULT_PAGE_SIZE = 100;
